import React, { useEffect, useState , useCallback } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import { Link } from "react-router-dom";
import ProfileCard from "@/components/ProfileCard";
import { Heart, Wallet as WalletIcon, ShieldCheck } from "lucide-react";

export default function ClientDashboard() {
  const { user } = useAuth();
  const [favorites, setFavorites] = useState([]);

  useEffect(() => {
    (async () => {
      try { const { data } = await api.get("/favorites"); setFavorites(data.profiles || []); } catch (e) { console.warn("[ClientDashboard.jsx] non-blocking error:", e); }
    })();
  }, []);

  if (!user) return null;

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-testid="client-dashboard">
      <p className="text-overline">Client</p>
      <h1 className="font-heading text-4xl text-white mt-2 mb-8 font-light">Welcome, {user.name}</h1>

      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-12">
        <div className="card-luxe rounded-lg p-6">
          <WalletIcon className="w-5 h-5 text-gold mb-2" strokeWidth={1.5} />
          <p className="text-overline">Credits</p>
          <p className="font-heading text-3xl text-white mt-1">{user.credits ?? 0}</p>
          <Link to="/wallet" className="text-xs text-gold mt-2 inline-block">Top up →</Link>
        </div>
        <div className="card-luxe rounded-lg p-6">
          <Heart className="w-5 h-5 text-gold mb-2" strokeWidth={1.5} />
          <p className="text-overline">Favorites</p>
          <p className="font-heading text-3xl text-white mt-1">{favorites.length}</p>
        </div>
        <div className="card-luxe rounded-lg p-6">
          <ShieldCheck className="w-5 h-5 text-gold mb-2" strokeWidth={1.5} />
          <p className="text-overline">Account</p>
          <p className="text-sm text-white mt-1">{user.email}</p>
        </div>
      </div>

      <h2 className="font-heading text-2xl text-white mb-6">Your favorites</h2>
      {favorites.length === 0 ? (
        <div className="card-luxe rounded-lg p-10 text-center">
          <p className="text-[#a3a3a3]">No favorites yet.</p>
          <Link to="/directory" className="btn-gold rounded-md px-5 py-2.5 text-sm mt-4 inline-block">Browse directory</Link>
        </div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5">
          {favorites.map((p) => <ProfileCard key={p.id} profile={p} isFavorite onFavorite={() => {}} />)}
        </div>
      )}
    </div>
  );
}
